import {
    defaultBaseQuery,
    transformErrorResponse,
    transformRequest,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const commonAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'commonAPI',
    endpoints: (builder) => ({

        getDepartmentDesignationDropdowns: builder.query({
            query: () => ({
                url: `/dropdowns?pageName=COMMON_DROPDOWNS`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
});

export const {
    useLazyGetDepartmentDesignationDropdownsQuery
} = commonAPI;

export default commonAPI;
